var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
export var initialState = {
    view: null,
    viewLoaded: false,
    filter: {
        page: 1,
        sort: 'rank',
        marksCheck: [],
        blockPage: 10,
        pageSize: 10,
        marks: 0
    },
    topFilterNum: 'rank',
    setReviewLoadingState: false,
    reviewInfo: null,
    comment: {
        writer: {},
    },
    galleryData: {},
    galleryItem: 0 //갤러리 파일 순서 번호(상품평의 첨부파일 중 몇번째의 첨부파일인지)
};
export var REVIEW_LIST_REQUEST = 'REVIEW_LIST_REQUEST';
export var REVIEW_LIST_SUCCESS = 'REVIEW_LIST_SUCCESS';
export var REVIEW_LIST_FAILURE = 'REVIEW_LIST_FAILURE';
export var SET_FILTER_REVIEW = 'SET_FILTER_REVIEW';
export var SET_FILTER_TOP_STATE = 'SET_FILTER_TOP_STATE';
export var SET_REVIEW_LOADING_STATE = 'SET_REVIEW_LOADING_STATE';
export var GET_REVIEW_INFO = "GET_REVIEW_INFO";
export var GET_REVIEW_INFO_SUCCESS = "GET_REVIEW_INFO_SUCCESS";
export var GET_REVIEW_INFO_FAILURE = "GET_REVIEW_INFO_FAILURE";
export var SET_REVIEW_COMMENT_CREATE = "SET_REVIEW_COMMENT_CREATE";
export var SET_REVIEW_COMMENT_UPDATE = "SET_REVIEW_COMMENT_UPDATE";
export var SET_REVIEW_COMMENT_DELETE = "SET_REVIEW_COMMENT_DELETE";
export var SET_REVIEW_GALLERY_ITEM = "SET_REVIEW_GALLERY_ITEM";
export var SET_REVIEW_LIKE = "SET_REVIEW_LIKE";
export var SET_REVIEW_HATE = "SET_REVIEW_HATE";
export var SET_FILTER_REVIEW_RESET = "SET_FILTER_REVIEW_RESET";
var Reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    return produce(state, function (draft) {
        var _a, _b, _c, _d, _e, _f, _g;
        switch (action.type) {
            //
            case REVIEW_LIST_REQUEST: {
                break;
            }
            case REVIEW_LIST_SUCCESS: {
                draft.viewLoaded = true;
                draft.view = action.data;
                break;
            }
            case REVIEW_LIST_FAILURE: {
                draft.viewLoaded = true;
                break;
            }
            //
            case SET_FILTER_REVIEW: {
                draft.filter = __assign(__assign({}, state.filter), action.payload);
                break;
            }
            case SET_FILTER_TOP_STATE: {
                draft.topFilterNum = action.payload;
                break;
            }
            case SET_REVIEW_LOADING_STATE: {
                draft.setReviewLoadingState = action.payload;
                break;
            }
            case GET_REVIEW_INFO: {
                break;
            }
            case GET_REVIEW_INFO_SUCCESS: {
                draft.viewLoaded = true;
                draft.reviewInfo = action.data;
                if (((_b = (_a = action === null || action === void 0 ? void 0 : action.data) === null || _a === void 0 ? void 0 : _a.auth) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    draft.comment = {
                        writer: __assign({}, (_c = action === null || action === void 0 ? void 0 : action.data) === null || _c === void 0 ? void 0 : _c.auth[0]),
                    };
                }
                if (((_e = (_d = action === null || action === void 0 ? void 0 : action.data) === null || _d === void 0 ? void 0 : _d.reviewImages) === null || _e === void 0 ? void 0 : _e.length) > 0) {
                    var galleryImages = (_f = action === null || action === void 0 ? void 0 : action.data) === null || _f === void 0 ? void 0 : _f.reviewImages;
                    var galleryCount = (_g = action === null || action === void 0 ? void 0 : action.data) === null || _g === void 0 ? void 0 : _g.reviewImagesCount;
                    var images = [];
                    var imageCount = 0; // 각 아이디마다 이미지 순서 부여
                    var emptyId = 0; // 이전 이후 아이디값 비교
                    for (var i = 0; i < galleryImages.length; i++) {
                        var id = galleryImages[i].id;
                        var files = galleryImages[i].files;
                        for (var j = 0; j < files.length; j++) {
                            if (emptyId !== id) {
                                emptyId = id;
                                imageCount = 0;
                            }
                            else {
                                imageCount++;
                            }
                            images.push({ id: id, fileMimeType: files[j].fileMimeType, thumbUrl: files[j].fileThumbUrl, fileName: files[j].fileName, fileArrSort: imageCount });
                            // if(imageCount===8) break
                        }
                        // if(imageCount===8) break
                    }
                    draft.galleryData = { images: images, count: galleryCount };
                }
                else {
                    draft.galleryData = {};
                }
                break;
            }
            case GET_REVIEW_INFO_FAILURE: {
                draft.viewLoaded = true;
                break;
            }
            case SET_REVIEW_COMMENT_CREATE: {
                var lists = state.view.threads;
                var reviewIndex_1 = lists.findIndex(function (v) { return v.id === action.payload.review_id; });
                if (reviewIndex_1 !== -1) {
                    // 기존 comments에 등록한 comment추가
                    var updateComments_1 = __spreadArray([action.payload.review_data], lists[reviewIndex_1].comments, true);
                    // draft.view 업데이트
                    draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                            return i === reviewIndex_1
                                ? __assign(__assign({}, thread), { comments: updateComments_1 }) : thread;
                        }) });
                }
                break;
            }
            case SET_REVIEW_COMMENT_UPDATE: {
                var lists = state.view.threads;
                var reviewIndex_2 = lists.findIndex(function (v) { return v.id === action.payload.review_id; });
                if (reviewIndex_2 !== -1) {
                    var comments = lists[reviewIndex_2].comments;
                    var commentIndex = comments.findIndex(function (v) { var _a; return (v === null || v === void 0 ? void 0 : v.id) === ((_a = action.payload.comment_data) === null || _a === void 0 ? void 0 : _a.id); });
                    if (commentIndex !== -1) {
                        var updatedComments_1 = __spreadArray(__spreadArray(__spreadArray([], comments.slice(0, commentIndex), true), [
                            action.payload.comment_data
                        ], false), comments.slice(commentIndex + 1), true);
                        draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                                return i === reviewIndex_2
                                    ? __assign(__assign({}, thread), { comments: updatedComments_1 }) : thread;
                            }) });
                    }
                }
                break;
            }
            case SET_REVIEW_COMMENT_DELETE: {
                var lists = state.view.threads;
                var review_id = action.payload.review_id;
                var comment_id_1 = action.payload.comment_id;
                var reviewIndex_3 = lists.findIndex(function (v) { return v.id === action.payload.review_id; });
                if (reviewIndex_3 !== -1) {
                    var existingThread = lists[reviewIndex_3];
                    var updatedComments_2 = existingThread.comments.filter(function (comment) { return comment.id !== comment_id_1; });
                    draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                            return i === reviewIndex_3
                                ? __assign(__assign({}, thread), { comments: updatedComments_2 }) : thread;
                        }) });
                }
                break;
            }
            case SET_REVIEW_GALLERY_ITEM: {
                draft.galleryItem = action.payload.galleryItem;
                break;
            }
            case SET_REVIEW_LIKE: {
                var lists = state.view.threads;
                var flag = action.payload.flag;
                var review_id_1 = action.payload.review_id;
                var reviewIndex_4 = lists.findIndex(function (v) { return v.id === review_id_1; });
                if (reviewIndex_4 !== -1) {
                    var existingThread = lists[reviewIndex_4];
                    var updatedThread_1 = __assign({}, existingThread); // 기존 스레드 복사
                    if (flag === 'lt') {
                        updatedThread_1 = __assign(__assign({}, updatedThread_1), { hasMyLike: true, countLike: updatedThread_1.countLike + 1 });
                    }
                    else if (flag === 'lthf') {
                        updatedThread_1 = __assign(__assign({}, updatedThread_1), { hasMyLike: true, hasMyHate: false, countLike: updatedThread_1.countLike + 1 });
                    }
                    draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                            return i === reviewIndex_4 ? updatedThread_1 : thread;
                        }) });
                }
                break;
            }
            case SET_REVIEW_HATE: {
                var lists = state.view.threads;
                var flag = action.payload.flag;
                var review_id_2 = action.payload.review_id;
                var reviewIndex_5 = lists.findIndex(function (v) { return v.id === review_id_2; });
                if (reviewIndex_5 !== -1) {
                    var existingThread = lists[reviewIndex_5];
                    var updatedThread_2 = __assign({}, existingThread); // 기존 스레드 복사
                    if (flag === 'lfht') {
                        updatedThread_2 = __assign(__assign({}, updatedThread_2), { hasMyLike: false, hasMyHate: true, countLike: updatedThread_2.countLike - 1 });
                    }
                    draft.view = __assign(__assign({}, draft.view), { threads: lists.map(function (thread, i) {
                            return i === reviewIndex_5 ? updatedThread_2 : thread;
                        }) });
                }
                break;
            }
            case SET_FILTER_REVIEW_RESET: {
                draft.filter = {
                    page: 1,
                    sort: 'rank',
                    marksCheck: [],
                    blockPage: 10,
                    pageSize: 10,
                    marks: 0
                };
                break;
            }
            default: {
                break;
            }
        }
    });
};
// export function setTopFiledNum(num : number) {
//     console.log("action num = ",num)
//     return {
//         type: SET_FILTER_TOP_STATE,
//         stateNum: num,
//     }
// }
export default Reducer;



//////////////////
// WEBPACK FOOTER
// ./src/detail/reducers/review.ts
// module id = 9
// module chunks = 0